import React, { useState } from "react";
import {
  CardFan,
  Divider,
  FanCard,
  Footnote,
  HomeContainer,
  Hero,
  Panel,
  Tagline,
} from "./Home.styles";
import { Button } from "@mui/material";
import { PATHS } from "../../routes";
import GameSettingsModal from "../GameSettingsModal/GameSettingsModal";
import JoinModal from "../JoinModal/JoinModal";
import Icon from "../ui/Icon";
import BrandMark from "../ui/BrandMark";
import Wordmark from "../ui/Wordmark";
import DoodleBackground from "../ui/DoodleBackground";

const Home: React.FC = () => {
  const [joinGameModal, setJoinGameModal] = useState(false);
  const [newGameModal, setNewGameModal] = useState(false);

  return (
    <>
      <DoodleBackground />
      <HomeContainer>
        <Hero>
          <CardFan aria-hidden>
            <FanCard $tilt={-14} $x={-52}>
              Minha sogra.
              <BrandMark size={16} />
            </FanCard>
            <FanCard $dark $tilt={0} $x={0}>
              O que estraga um almoço de domingo? ____.
              <BrandMark size={16} />
            </FanCard>
            <FanCard $tilt={14} $x={52}>
              Um pum silencioso.
              <BrandMark size={16} />
            </FanCard>
          </CardFan>

          <Wordmark />

          <Tagline>
            O jogo de cartas irreverente e de humor pesado, inspirado em Cartas
            Contra a Humanidade. Junte a galera e jogue online!
          </Tagline>

          <Panel>
            <Button
              variant="contained"
              size="large"
              onClick={() => setNewGameModal(true)}
              startIcon={<Icon name="create" />}
              fullWidth
            >
              Criar nova partida
            </Button>

            <Divider>ou</Divider>

            <Button
              variant="outlined"
              size="large"
              onClick={() => setJoinGameModal(true)}
              startIcon={<Icon name="enter" />}
              fullWidth
            >
              Entrar em uma partida
            </Button>
          </Panel>

          <Footnote>Indicado para maiores de 18 anos. Pode pesar.</Footnote>
        </Hero>
      </HomeContainer>

      <GameSettingsModal
        visible={newGameModal}
        onClose={() => setNewGameModal(false)}
      />

      <JoinModal
        show={joinGameModal}
        onClose={() => setJoinGameModal(false)}
        onJoin={(code) => window.location.assign(PATHS.GAME.PLAY(code))}
      />
    </>
  );
};

export default Home;
